import gql from 'graphql-tag';

export class DocumentaryManagementRecordFragment {
    static recordListFragment = gql`
    fragment ListeAlbumsFragment on GEDListeAlbumsGEDModel {
        NbElementTot
        ListeAlbums {
            PortailAlbumDTO {
                CeDelegation {
                    Id
                    CENom
                    CEIdCclo
                    CEIdcGlob
                }
                DateDebut
                DateFin
                Description
                Id
                Libelle

                ListeArticles {
                    PortailArticleDTO {
                        Id
                        DateCreation
                        Statut {
                            Id
                            Code
                            Libelle
                            IsActif
                        }
                        Titre

                        # *** pas sur ***
                        AddedImagesIds {
                            int
                        }
                        CanComment
                        CanLike
                        Categorie {
                            Id
                            Libelle
                        }
                        CeDelegation {
                            Id
                        }
                        ChapeauPersonnalise
                        Corps
                        CorpsActu
                        DateDebutPublication
                        DateFinPublication
                        DateMAJ
                        DiffusionArticleModel {
                            Id
                        }
                        Illustration {
                            IdFile
                        }
                        IsActualite
                        IsAnonyme
                        IsAnonymeParDefaut
                        IsMasquerInfosPublication
                        IsModificationPossibleParLocal
                        IsPublic
                        LastUserMaj {
                            Id
                            Nom
                            Prenom
                        }
                        ListeAlbums {
                            PortailAlbumDTO {
                                Id
                                Libelle
                            }
                        }
                        ListeCommentaires {
                            PortailArticleCommentaireDTO {
                                Id
                            }
                        }
                        ListeCommissions {
                            decimal
                        }
                        ListeDocuments {
                            FichierModel {
                                IdFile
                                Filename
                            }
                        }
                        ListeLikes {
                            PortailArticleLikeDTO {
                                Id
                            }
                        }
                        ListeParamValeur {
                            PortailArticleParamValDTO {
                                Parametre {
                                    Code
                                    Id
                                }
                                Valeur
                            }
                        }
                        MailNotifAutoCommentaire
                        MenuPortailParent {
                            Id
                        }
                        ModereComentaire
                        OrdreMenu
                        TypeArticle {
                            Id
                            Libelle
                        }
                        TypeOrdre
                        UserCreation {
                            Id
                            Nom
                            Prenom
                        }
                    }
                }

                ListeDocumentAlbum {
                    PortailDocumentAlbumDTO {
                        Document {
                            AlbumId
                            AlbumName
                            CategCode
                            CategorieLibelle
                            DateCreation
                            DateDebut
                            DateFin
                            EditCategCode
                            EditCategLibelle
                            Extension
                            FileBytes
                            Filename
                            IdFile
                            IdLienFichier
                            IsCommentable
                            IsFichierClient
                            IsLikeable
                            LibelleLien
                            OrigineCode
                            RemarqueLien
                            StatutCode
                            StatutLibelle
                            Tags {
                                string
                            }
                            Taille
                            Token
                            TypeFichierIcone
                            TypeFichierLibelle
                            Url
                        }
                    }
                }

                ListeDocumentsToSave {
                    FichierCompletModel {
                        AlbumId
                        AlbumName
                        CategCode
                        CategorieLibelle
                        DateCreation
                        DateDebut
                        DateFin
                        EditCategCode
                        EditCategLibelle
                        Extension
                        FileBytes
                        Filename
                        IdFile
                        IdLienFichier
                        IsCommentable
                        IsFichierClient
                        IsLikeable
                        LibelleLien
                        OrigineCode
                        RemarqueLien
                        StatutCode
                        StatutLibelle
                        Tags {
                            string
                        }
                        Taille
                        Token
                        TypeFichierIcone
                        TypeFichierLibelle
                        Url
                    }
                }

                Statut {
                    Code
                    Id
                    IsActif
                    Libelle
                }
            }
        }
    }
    `
}
